import React from 'react';
import {Link} from 'react-router';
import ThemableSvgIcon from "./theme/ThemableSvgIcon";

function BackLink(props) {
    if(props.isExternal) {
        return (
            <a className="text-primary inline-flex items-center hover:underline" href={props.to}>
                <ThemableSvgIcon name="chevron-left" className="w-4 h-4 inline"/> {props.text}
            </a>
        )
    }
    return (
        <Link className="text-primary inline-flex items-center hover:underline" to={props.to}>
            <ThemableSvgIcon name="chevron-left" className="w-4 h-4 inline"/> {props.text}
        </Link>
    );
}

export default BackLink;